// Recently viewed (product.md 4.26). Cookie recentlyViewed: URL-escaped, comma-separated product handles,
// most recent first, no duplicates, capped at 20 (decisions.md #4), 30 days, path /, SameSite=None; Secure.
(() => {
  if (window.recentlyViewed) return;
  const NAME = 'recentlyViewed';
  const MAX = 20;
  const getHandles = () => {
    const match = document.cookie.match(/(?:^|;\s*)recentlyViewed=([^;]*)/);
    if (!match) return [];
    return decodeURIComponent(match[1]).split(',').filter(Boolean);
  };
  const add = (handle) => {
    if (!handle) return;
    const handles = [handle, ...getHandles().filter((h) => h !== handle)].slice(0, MAX);
    const expires = new Date(Date.now() + 30 * 864e5).toUTCString();
    document.cookie = `${NAME}=${encodeURIComponent(handles.join(','))}; expires=${expires}; path=/; SameSite=None; Secure`;
  };
  window.recentlyViewed = { getHandles, add, MAX };

  // Read the list before recording this visit, so the section never shows the current product.
  const current = document.querySelector('[data-rv-handle]')?.dataset.rvHandle;

  if (!customElements.get('recently-viewed')) {
    customElements.define(
      'recently-viewed',
      class RecentlyViewed extends HTMLElement {
        connectedCallback() {
          if (this.dataset.recentlyViewedItemsLoaded) return;
          this.dataset.recentlyViewedItemsLoaded = 'true';
          const skip = this.dataset.currentHandle || current;
          const handles = getHandles().filter((h) => h !== skip).slice(0, parseInt(this.dataset.visibleProducts, 10) || 4);
          const slots = Array.from(this.querySelectorAll('[data-rv-slot]'));
          Promise.all(
            handles.map((handle, index) =>
              fetch(`${this.dataset.cardUrl}${encodeURIComponent(handle)}?section_id=recently-viewed-card`)
                .then((response) => (response.ok ? response.text() : ''))
                .then((text) => {
                  const card = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-rv-card]');
                  if (!card || !slots[index]) return false;
                  card.classList.add('rv-element', 'js-recently-viewed-product');
                  slots[index].append(card);
                  slots[index].hidden = false;
                  return true;
                })
                .catch(() => false)
            )
          ).then((results) => {
            slots.forEach((slot) => !slot.childElementCount && slot.remove());
            if (results.some(Boolean)) {
              this.classList.remove('hidden');
              window.Shopify?.PaymentButton?.init();
              document.dispatchEvent(new CustomEvent('recently-viewed:loaded', { detail: { element: this } }));
            }
          });
        }
      }
    );
  }

  add(current);
})();
